import React, { useRef } from 'react';
import { Whisper } from 'rsuite';
import { FilterPopover } from '@/property-filter/filter-popover';

export function CardFilterPopover(props) {
  const whisperRef = useRef(null);
  const {
    availableViolations,
    availablePlatforms,
    platformIcons,
    strComplaintsAvailable,
    setSingleFilterParam,
    filterButtonRef,
    setFiltersOpen,
    setCurrentPage,
  } = props;

  const handleClose = () => {
    whisperRef.current?.close();
    setFiltersOpen(false);
  };

  return (
    <Whisper
      ref={whisperRef}
      onEntering={() => setFiltersOpen(true)}
      onExiting={() => setFiltersOpen(false)}
      trigger="click"
      placement="bottom"
      speaker={
        <FilterPopover
          availableViolations={availableViolations}
          availablePlatforms={availablePlatforms}
          platformIcons={platformIcons}
          strComplaintsAvailable={strComplaintsAvailable}
          filterButtonRef={filterButtonRef}
          setSingleFilterParam={setSingleFilterParam}
          onClose={handleClose}
          setCurrentPage={setCurrentPage}
        />
      }
    >
      <div>{props.children}</div>
    </Whisper>
  );
}
